export class Project{
    name: String;
    category: String;
    image: String;
    intro: String;
    desc: String;
    date: String;
    client: String;

    constructor( name: String, desc: String, image: String,
             date?: String, client?: String ) {
            this.name = name || '' ;
            this.image = image || '';
            this.desc = desc || '';
            this.date = date || '';
            this.client = client || '';
    }
}